module.exports = __webpack_public_path__ + "img/CM-AE-25-Subaru-Playful.8f988072.jpg";